export default class Cancel {
  message?: string;
  constructor(message?: string) {
    this.message = message;
  }
}

// 判断是否被取消
export function isCancel(value: any): boolean {
  return value instanceof Cancel;
}

